import { createAction, handleActions } from 'redux-actions';
// - Actions

export const fetchPoliciesRequest = createAction('FETCH_POLICIES_REQUEST');
export const fetchPoliciesSuccess = createAction('FETCH_POLICIES_SUCCESS');

export const deletePolicyRequest = createAction('DELETE_POLICY_REQUEST');


export const failure = createAction('POLICIES_ACTION_FAILURE');


// - Initial State
export const initialState = {
  policies: [],
  pagination: {
    Page: 1,
    Size: 50,
    Total: 0
  },
  loading: false,

  error: null,
};

// - Reducers
const reducer = handleActions({
  [fetchPoliciesRequest]: (state) => {
    return { ...state, loading: true };
  },
  [fetchPoliciesSuccess]: (state, {payload: { policies }}) => {
    return { ...state, policies, loading: false  };
  },

  [failure]: (state, action) => ({
    ...state,
    error: action.error,
    loading: false,
  }),
}, initialState);

export default reducer;
